// const DEV_BASE_URL = 'ws://localhost:8082'
// const DEV_BASE_URL = "ws://123.60.170.219:8082";


//const DEV_BASE_URL = "ws://1.92.85.51:8080";
const DEV_BASE_URL = "ws://"+window.server.SOCKET_ADDRESS;
// const DEV_BASE_URL = "ws://38.12.33.187:8080";
export default {
  BASE_API: DEV_BASE_URL,
};
